if (!customElements.get('campaign-countdown')) {
  customElements.define(
    'campaign-countdown',
    class CampaignCountdown extends HTMLElement {
      connectedCallback() {
        // Server-authoritative: `data-remaining` is the number of seconds
        // left, computed in Liquid. The client never reads its own wall
        // clock as an absolute value — it only measures elapsed local time
        // (a duration) via performance.now(), so a wrong or manipulated
        // device clock can't produce a false countdown.
        const total = parseInt(this.dataset.remaining, 10);
        if (!Number.isFinite(total) || total <= 0) {
          this.hidden = true;
          return;
        }

        this.total = total;
        this.startedAt = performance.now();
        this.dEl = this.querySelector('[data-campaign-countdown-d]');
        this.hEl = this.querySelector('[data-campaign-countdown-h]');
        this.mEl = this.querySelector('[data-campaign-countdown-m]');

        this.tick();
        this.intervalId = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }

      tick() {
        const elapsed = Math.floor((performance.now() - this.startedAt) / 1000);
        const remaining = this.total - elapsed;

        if (remaining <= 0) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          this.hidden = true;
          return;
        }

        const days = Math.floor(remaining / (60 * 60 * 24));
        const hours = Math.floor((remaining % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((remaining % (60 * 60)) / 60);

        this.setChip(this.dEl, String(days).padStart(2, '0'));
        this.setChip(this.hEl, String(hours).padStart(2, '0'));
        this.setChip(this.mEl, String(minutes).padStart(2, '0'));

        this.hidden = false;
      }

      setChip(el, value) {
        if (el && el.textContent !== value) el.textContent = value;
      }
    }
  );
}
